const React = require('react');

const Container = require('../common/Container.jsx');
const _TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

function Notes(props) {
    const data = props.data || {};
    if (!props.builder && Utilities.isNullOrWhitespace(data.Notes)) {
        return null;
    }
    const config = props.config || {};
    let blockProps = {};
    let includes = {};
    if (config.Config) {
        if (config.Config.Block) {
            blockProps = config.Config.Block;
        }
        if (config.Config.Includes) {
            includes = config.Config.Includes;
        }
    }
    let styleHeader;
    if (includes.HeaderLabel) {
        styleHeader = Utilities.Config.getStyle(data, blockProps, 'Header');
    }
    const styleNote = Utilities.Config.getStyle(data, blockProps, 'Note');
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragStart={props.onDragStart}>
            {
                includes.HeaderLabel &&
                <tr>
                    <td>
                        <div style={styleHeader}>{blockProps.textLabelHeader}</div>
                    </td>
                </tr>
            }
            <tr>
                <td>
                    <div dangerouslySetInnerHTML={{ __html: data.Notes }} style={styleNote} />
                    {
                        props.builder &&
                        <React.Fragment>
                            {
                                !includes.HeaderLabel &&
                                Utilities.isNullOrWhitespace(data.Notes) &&
                                Utilities.Builder.emptyBlockPlaceholder()
                            }
                            {Utilities.Builder.dragOutline()}
                        </React.Fragment>
                    }
                </td>
            </tr>
        </Container>
    );
}

const TypeConfig = {
    panel: {
        block: function (header) {
            let headerLabelValue = 'Notes';
            if (header && header.value) {
                headerLabelValue = header.value;
            }
            return {
                label: 'Block Configuration',
                options: [
                    { display: 'Header Label Properties', id: 'headerProps', type: 'header' },
                    {
                        display: 'Display Text',
                        name: 'textLabelHeader',
                        type: 'text',
                        value: headerLabelValue
                    },
                    { type: 'spacer' },
                    ..._TypeConfig.options.text({ name: 'Header' }, {}, undefined, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Note Properties', id: 'noteProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'Note' }, {}, {})
                ]
            }
        },
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'Header Label', name: 'HeaderLabel', type: 'checkbox', value: true }
                ]
            };
        },
        style: function () { return _TypeConfig.panel.layoutStyle({}, {}); }
    }
};

module.exports = {
    Component: Notes,
    TypeConfig
};